<template>
  <div class="lista-beneficiarios">
    <p class="text-sm-left title-table">LISTA DE BENEFICIARIOS</p>
    <v-layout justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card class="elevation-3">
          <v-card-title class="pa-0 search-bar">
            <v-layout row wrap>
              <v-flex
                xs12
                sm12
                md10
                lg10
                xl10
                v-bind:class="{ 'md12 lg12 xl12': magic_flag }"
              >
                <v-text-field
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  @focus="magic_flag = true"
                  @blur="magic_flag = false"
                  label="Buscar por nombre,CURP,municipio ó localidad"
                  v-model="search"
                ></v-text-field>
              </v-flex>
              <v-flex
                class="hidden-sm-and-down"
                v-if="!magic_flag"
                xs12
                sm12
                md2
                lg2
                xl2
              >
                <v-layout justify-end row>
                  <v-tooltip top>
                    <v-btn icon slot="activator" @click="refreshTableBenf">
                      <v-icon>refresh</v-icon> </v-btn
                    >Actualizar
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn icon slot="activator" @click="exportPDF">
                      <v-icon>print</v-icon> </v-btn
                    >Exportar
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn icon slot="activator" @click="reportePDF">
                      <v-icon>insert_chart</v-icon> </v-btn
                    >Reporte
                  </v-tooltip>
                </v-layout>
              </v-flex>
              <v-flex class="hidden-md-and-up" xs12 sm12>
                <v-layout justify-center row>
                  <v-flex xs2 sm1 d-flex justify-center>
                    <v-tooltip top>
                      <v-btn icon slot="activator" @click="refreshTableBenf">
                        <v-icon>refresh</v-icon> </v-btn
                      >Actualizar
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs2 sm1 d-flex justify-center>
                    <v-tooltip top>
                      <v-btn icon slot="activator" @click="exportPDF">
                        <v-icon>print</v-icon> </v-btn
                      >Exportar
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :rows-per-page-text="textPaginas"
            :rows-per-page-items="arrItems"
            :loading="loading"
            :custom-filter="filtrarElementos"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ props.header.text }}</span>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="justify-center layout px-0">
                <v-tooltip bottom v-if="evento_id != 8">
                  <v-btn
                    icon
                    class="mx-0"
                    v-on:click="marcarAsistencia(props.item)"
                    slot="activator"
                  >
                    <v-icon :color="props.item.asistencia ? 'success' : 'error'"
                      >check_circle</v-icon
                    >
                  </v-btn>
                  <span>Marcar asistencia</span>
                </v-tooltip>
                <v-tooltip bottom v-if="evento_id != 8">
                  <v-btn
                    icon
                    class="mx-0"
                    v-on:click="abrirInvitado(props.item)"
                    slot="activator"
                  >
                    <v-icon color="info">assignment_ind</v-icon>
                  </v-btn>
                  <span>Agregar invitado</span>
                </v-tooltip>
                <v-tooltip bottom v-if="evento_id == 8">
                  <v-btn
                    icon
                    class="mx-0"
                    v-on:click="editarPersona(props.item)"
                    slot="activator"
                  >
                    <v-icon :color="'warning'">border_color</v-icon>
                  </v-btn>
                  <span>Editar persona</span>
                </v-tooltip>
                <v-tooltip top v-if="evento_id == 8">
                  <v-btn
                    icon
                    class="mx-0"
                    slot="activator"
                    @click="eliminarPersona(props.item)"
                  >
                    <v-icon :color="'error'">delete</v-icon>
                  </v-btn>
                  <span>Eliminar persona</span>
                </v-tooltip>
                <v-tooltip top v-if="evento_id == 8">
                  <v-btn
                    icon
                    class="mx-0"
                    slot="activator"
                    @click="abrirDialog(props.item)"
                  >
                    <v-icon :color="'info'">assignment_ind</v-icon>
                  </v-btn>
                  <span>Editar responsable</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.servicio }}</td>
              <td class="text-xs-left">
                {{ props.item.nombre }}&nbsp;{{
                  props.item.primer_apellido
                }}&nbsp;{{ props.item.segundo_apellido }}
              </td>
              <td class="text-xs-left">{{ props.item.curp }}</td>
              <td class="text-xs-center justify-center">
                {{ props.item.edad }}
              </td>
              <td class="text-xs-center justify-center">
                {{ props.item.telefono }}
              </td>
              <td class="text-xs-left">{{ props.item.municipio }}</td>
              <td class="text-xs-left">{{ props.item.localidad }}</td>
              <td class="text-xs-center">{{ props.item.codigo_postal }}</td>
            </template>
            <template
              slot="pageText"
              slot-scope="{ pageStart, pageStop, itemsLength }"
              >{{ pageStart }} - {{ pageStop }} de {{ itemsLength }}</template
            >
            <template slot="no-data">
              <v-alert :value="true" color="warning" icon="warning"
                >Lo siento, no se encontraron datos.</v-alert
              >
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              >No se encontraron resultados para: "{{ search }}".</v-alert
            >
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogLoader" max-width="250px" persistent>
      <Loader></Loader>
    </v-dialog>
    <!-- modal para agregar responsables, solo evento 8 -->
    <div class="text-center">
      <v-dialog v-model="editarResponsable" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Editar Responsable</v-card-title
          >
          <v-form v-model="valid" ref="form">
            <v-card-text>
              <v-text-field
                label="Nombre"
                placeholder="Nombre del responsable"
                outlined
                v-model="nombreResponsable"
                :rules="nombreRules"
              ></v-text-field>
              <v-text-field
                label="Primer Apellido"
                placeholder="Primer apellido del responsable"
                outlined
                v-model="primerApellidoResponsable"
                :rules="apellidoRules"
              ></v-text-field>
              <v-text-field
                label="Segundo Apellido"
                placeholder="Segundo apellido del responsable"
                outlined
                v-model="segundoApellidoResponsable"
              ></v-text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="default" text @click="cerrarDialog">Cancelar</v-btn>
              <v-btn color="primary" text @click="actualizarResponsable"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
    <!-- modal para agregar acompañantes, evento de presidentas -->
    <div class="text-center">
      <v-dialog v-model="agregandoInvitado" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Agregar acompañante</v-card-title
          >
          <v-form v-model="valid" ref="form">
            <v-card-text>
              <v-text-field
                label="Nombre"
                placeholder="Nombre del acompañante"
                outlined
                v-model="nombreInvitado"
                :rules="nombreRules"
              ></v-text-field>
              <v-text-field
                label="Primer Apellido"
                placeholder="Primer apellido del acompañante"
                outlined
                v-model="primerApellidoInvitado"
                :rules="apellidoRules"
              ></v-text-field>
              <v-text-field
                label="Segundo Apellido"
                placeholder="Segundo apellido del acompañante"
                outlined
                v-model="segundoApellidoInvitado"
              ></v-text-field>
              <v-select
                :items="cargos"
                item-value="id"
                item-text="nombre"
                v-model="cargoInvitado"
                label="Mostrar:"
                color="#D81B60"
                placeholder="Cargo del acompañante"
              ></v-select>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="default" text @click="cerrarInvitado"
                >Cancelar</v-btn
              >
              <v-btn color="primary" text @click="guardarInvitado"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
    <!-- fin de los modals -->
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import GlogalJS from "../mixins/GlobalJs";
import swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import jsreport from "jsreport-browser-client-dist";

export default {
  name: "Beneficiarios",
  props: ["evento_id"],
  mixins: [GlogalJS],
  components: {
    Loader,
  },
  data: () => ({
    magic_flag: false,
    dialogBeneficiario: false,
    dialogLoader: false,
    loading: false,
    items: [],
    search: "",
    textPaginas: "Registros por pagina:",
    arrItems: [10, 25, 50, { text: "...", value: -1 }],
    headers: [
      { text: "ACCIONES", value: "", align: "center" },
      { text: "#", value: "id", sortable: false },
      { text: "SERVICIO", value: "servicio", sortable: true },
      { text: "NOMBRE", value: "nombre" },
      { text: "CURP", value: "curp" },
      { text: "EDAD", value: "edad", align: "center" },
      { text: "TELEFONO", value: "telefono", align: "center" },
      { text: "MUNICIPIO", value: "municipio" },
      { text: "LOCALIDAD", value: "localidad" },
      { text: "CODIGO POSTAL", value: "codigo_postal" },
    ],
    editarResponsable: false,
    persona: null,
    nombreResponsable: "",
    primerApellidoResponsable: "",
    segundoApellidoResponsable: null,
    valid: false,
    nombreRules: [
      (v) => !!v || "El nombre es necesario",
      (v) => v.length >= 3 || "El nombre debe ser mayor a 3 caracteres",
    ],
    apellidoRules: [
      (v) => !!v || "El apellido es necesario",
      (v) => v.length >= 3 || "El apellido debe ser mayor a 3 caracteres",
    ],
    agregandoInvitado: false,
    nombreInvitado: "",
    primerApellidoInvitado: "",
    segundoApellidoInvitado: "",
    cargoInvitado: null,
    cargos: [],
  }),
  computed: {},
  mounted() {
    this.refreshTableBenf();
    jsreport.serverUrl = "https://reportes.difoaxaca.gob.mx";
    jsreport.headers["Authorization"] = "Basic " + btoa("difo:21qwerty43");
  },
  methods: {
    refreshTableBenf() {
      this.loading = true;
      axios
        .get(
          `${this.server_api}/eventos/${this.$route.params.evento_id}/personas`
        )
        .then((result) => {
          this.items = result.data.map((item) => {
            item.edad = moment().diff(item.fecha_nacimiento, "years");
            return item;
          });
        })
        .catch(() => {
          swal("Oops", "No pudimos cargar los eventos", "warning");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filtro(valor, search) {
      return (
        valor != null &&
        typeof valor !== "boolean" &&
        valor
          .toString()
          .toLowerCase()
          .indexOf(search) !== -1
      );
    },
    filtrarElementos() {
      let items = this.items.slice();
      let format_items = items.map((i) => {
        i.nombre_completo =
          i.nombre + " " + i.primer_apellido + " " + i.segundo_apellido;
        return i;
      });
      if (
        this.search != "" &&
        this.search != undefined &&
        this.search != null
      ) {
        let search = this.search.toString().toLowerCase();
        return format_items.filter((i) =>
          Object.keys(i).some((j) => this.filtro(i[j], search))
        );
      }
      return items;
    },
    marcarAsistencia(item) {
      /* swal.fire({
        title: "Por favor introduce el numero de ficha",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Marcar asistencia",
        calceButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: numFicha => {
          axios
            .put(`${this.server_api}/personas/${item.persona_id}`, {
              servicio_id: item.servicio_id,
              ficha: numFicha,
              asistencia: 1
            })
            .then(result => {
              swal("Great!", "Actualizado correctamente!", "success");
              item.asistencia = 1;
            })
            .catch(error => {
              swal("Oops!", "Error al actualizar" + error, "error");
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
      }); */
      if (item.asistencia == 1) return;
      axios
        .put(`${this.server_api}/personas/${item.persona_id}`, {
          servicio_id: item.servicio_id,
          asistencia: 1,
        })
        .then((result) => {
          swal("Great!", "Actualizado correctamente!", "success");
          item.asistencia = 1;
        })
        .catch((error) => {
          swal("Oops!", "Error al actualizar" + error, "error");
        });
    },
    exportPDF() {
      var request = {
        template: {
          shortid: "S1eq2L-fX8",
        },
        data: {
          titulo: this.items[0].servicio,
          subtitulo: "LISTA DE ASISTENCIA",
          cabeceras: [
            "ID",
            "SERVICIO",
            "NOMBRE",
            "PRIMER_APELLIDO",
            "SEGUNDO_APELLIDO",
            "CURP",
            "EDAD",
            "TELEFONO",
            "MUNICIPIO",
            "LOCALIDAD",
            "CODIGO POSTAL",
          ],
          datos: this.items
            .filter((f) => f.asistencia > 0)
            .map((e) => [
              e.id,
              e.servicio,
              e.nombre,
              e.primer_apellido,
              e.segundo_apellido,
              e.curp,
              e.edad,
              e.telefono,
              e.municipio,
              e.localidad,
              e.codigo_postal,
            ]),
        },
      };
      jsreport
        .renderAsync(request)
        .then(function(res2) {
          res2.download("asistentes.xlsl");
        })
        .catch(function(error) {
          Swal.fire("Error", "No se genero el dpf, " + error.message, "error");
          $.unblockUI();
        });
    },
    editarPersona(persona) {
      this.$router.push(
        `/home/${this.evento_id}/${persona.servicio_id}/${persona.persona_id}`
      );
    },
    eliminarPersona(persona) {
      swal({
        title: "Confirmar ?",
        text: "Se va a eliminar un beneficiario",
        showConfirmButton: true,
        showCancelButton: true,
        type: "question",
      }).then((result) => {
        if (result.value)
          axios
            .delete(
              `${this.server_api}/personas/${persona.persona_id}/servicios/${persona.servicio_id}`
            )
            .then((response) => {
              swal("Great!", "Registro eliminado", "success");
              this.refreshTableBenf();
            })
            .catch((error) =>
              swal("Oops", "No pudimos eliminar el registro", "warning")
            );
      });
    },
    abrirDialog(persona) {
      this.persona = persona;
      this.editarResponsable = true;
    },
    cerrarDialog() {
      this.persona = null;
      this.nombreResponsable = "";
      this.primerApellidoResponsable = "";
      this.segundoApellidoResponsable = null;
      this.editarResponsable = false;
    },
    actualizarResponsable() {
      if (!this.$refs.form.validate())
        return swal("Formulario no válido", "", "warning");
      axios
        .put(
          `${this.server_api}/personas/${this.persona.persona_id}/responsable`,
          {
            nombre: this.nombreResponsable,
            primer_apellido: this.primerApellidoResponsable,
            segundo_apellido: this.segundoApellidoResponsable,
          }
        )
        .then((response) => {
          this.cerrarDialog();
          swal("Great!", "Actualizado correctamente", "success");
        })
        .catch((error) => {
          swal("Oops!", "Algo salio mal", "warning");
          // eslint-disable-next-line
          console.log(error);
        });
    },
    abrirInvitado(persona) {
      this.persona = persona;
      this.agregandoInvitado = true;
      axios.get(`${this.server_api}/cargos`).then((res) => {
        this.cargos = res.data;
      });
    },
    cerrarInvitado() {
      this.agregandoInvitado = false;
    },
    guardarInvitado() {
      axios
        .post(
          `${this.server_api}/personas/${this.persona.persona_id}/invitado`,
          {
            nombre: this.nombreInvitado,
            primer_apellido: this.primerApellidoInvitado,
            segundo_apellido: this.segundoApellidoInvitado,
            cargo_id: this.cargoInvitado,
            municipio_id: this.persona.municipio_id,
            persona_id: this.persona.persona_id,
            servicio_id: this.persona.servicio_id,
          }
        )
        .then(() => {
          this.cerrarInvitado();
          swal("Great!", "Guardado correctamente", "success");
        })
        .catch((error) => {
          swal("Oops!", "Algo salio mal", "warning");
          // eslint-disable-next-line
          console.log(error);
        });
    },
    reportePDF() {
      axios
        .get(
          `${this.server_api}/eventos/${this.$route.params.evento_id}/reporte`
        )
        .then((result) => {
          var request = {
            template: {
              shortid: "SkxPjqcJEL",
            },
            data: result.data,
          };
          jsreport
            .renderAsync(request)
            .then(function(res2) {
              res2.download("reporte.pdf");
            })
            .catch(function(error) {
              Swal.fire(
                "Error",
                "No se genero el dpf, " + error.message,
                "error"
              );
              $.unblockUI();
            });
        })
        .catch(() => {
          swal("Oops", "No pudimos generar el reporte", "warning");
        });
    },
  },
};
</script>

<style>
.lista-beneficiarios {
  width: 100%;
  height: 100%;
}

.lista-beneficiarios
  .theme--light.v-text-field--solo-inverted.v-text-field--solo
  .v-input__slot {
  background: #fafafa;
}

.lista-beneficiarios
  .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  .v-input__slot {
  background: white !important;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.lista-beneficiarios
  .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  .v-input__slot
  .v-label {
  color: #9999998e;
}

.lista-beneficiarios
  .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  .v-input__slot
  input {
  color: black;
}

.lista-beneficiarios .search-bar .theme--light.v-label {
  color: #5c5c5c8e;
}

.lista-beneficiarios .search-bar .theme--light.v-icon {
  color: #5c5c5c8e;
}

.lista-beneficiarios thead {
  background-color: #fafafa;
}

.lista-beneficiarios .theme--light.v-datatable .v-datatable__actions {
  background-color: #fafafa;
}

.lista-beneficiarios .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.lista-beneficiarios .search-bar .primary--text {
  color: #98579b !important;
}

.search-bar {
  background-color: #fafafa;
}
</style>
